import { find } from 'lodash';

import { IntegrationProvidersTypes } from '~globals/types/enums';
import { integrationsProviders } from '~constants/integrationsProviders';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getIntegrationProviderData = (
  integrationType: IntegrationProvidersTypes,
) => find(integrationsProviders, { type: integrationType });
